import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Latest Updates</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">最新更新</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">实时掌握90影视最新上线内容与站点动态</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-secondary-200/60">
            {updates.map((item) => (
              <div key={item.id} className="relative mb-10 last:mb-0">
                <div className="absolute -left-[calc(2rem+5px)] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-2">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  <span className="text-xs bg-accent-100 text-accent-700 px-2 py-0.5 rounded-full inline-block w-fit whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}